export type AutomationType =
  | 'private'
  | 'episode_no'
  | 'date'
  | 'subtitle'
  | 'program_name_to_title';

export interface TitleAutoGenerator {
  id: number;
  slug: string;
  automation_type: AutomationType;
  automation_type_display: string;
  note: string | null;
  created: string;
  modified: string;
}

export interface CreateTitleAutoGeneratorRequest {
  slug: string;
  automation_type: AutomationType;
  note?: string | null;
}

export interface UpdateTitleAutoGeneratorRequest {
  slug?: string;
  automation_type?: AutomationType;
  note?: string | null;
}

export const AutomationTypeDisplay: Record<AutomationType, string> = {
  private: 'Private',
  episode_no: 'Episode Number',
  date: 'Date',
  subtitle: 'Subtitle',
  program_name_to_title: 'Program Name to Title',
};

export const AutomationTypeOptions = [
  { label: 'Private', value: 'private' },
  { label: 'Episode Number', value: 'episode_no' },
  { label: 'Date', value: 'date' },
];
